export default {
    headTitle: 'Dashboard - Kolsquare',
};
